/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-intersect',
  templateUrl: './theme-option-tooltips-intersect.component.html',
  styleUrls: ['./theme-option-tooltips-intersect.component.css']
})
export class ThemeOptionTooltipsIntersectComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_intersect';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption('tooltips_intersect', value);
  }

}
